import { initStore } from './store';

const configStore = () => {
  const actions = {
    SET: (curState, newState) => {
      return { ...curState, ...newState };
    },
    RESET_MESSAGES: (curState) => {
      return {
        ...curState,
        // showTicketMessage: false,
        showGroupMessage: false,
        showMaxMessage: false,
        showParkingMessage: false,
        showNoParkingMessage: false,
        showAvailabilityMessage: false,
        showMonthAvailabilityMessage: false
      }
    },
    RELEASE_TICKETS: (curState) => {
      return {
        ...curState,
        clearBasket: true,
        dateTimeConfirmed: false
      }
    }
  };
  initStore(actions, {
    wW: 0,
    pageID: null,
    pageTitle: '',
    selectedTab: 0,
    nextTab: null,
    step: 0,
    stepped: 0,
    stepNames: [],
    tabNames: [],
    customFields: null,
    intro: null,
    introTooltip: null,
    showLoader: true,
    rowDelay: 150,
    rows: 0,
    showBooking: false,
    initCalendar: false,
    showCalendar: false,
    showTicketMessage: false,
    familyTicketMessage: '',
    isGroup: false,
    showGroupMessage: false,
    showMaxMessage: false,
    showParkingMessage: false,
    showAvailabilityMessage: false,
    showMonthAvailabilityMessage: false,
    showSessionMessage: false,
    showRedeemedMessage: false,
    availMaxed: false,
    hidePackageAddons: false,
    firstAvailLabel: 'First available Studio Tour is ',
    dateTimeLabelFirst: 'The first available date & time is:',
    dateTimeLabelSelected: 'Your selected date & time is:',
    timesLoading: true,
    prevSection: null,
    fetchMonth: false,
    checkParking: true,
    parkingMaxed: false,
    isCrossSell: false,
    updateCart: false,
    timerActive: false,
    confirmTypeChange: false,
    confirmTimeChange: false,
    dateTimeConfirmed: false,
    clearBasket: false,
    orderConfirmed: false,
    faqs: [],
    buttonDisabled: false,
    giftAddonSelected: false,
    lightBoxImageUrl: null,
    isUS: false,
    sameAddress: false,
    paymentSubmitted: false,
    billingIsSet: false,
    fetchPaymentForm: false,
    disableTicketing: false,
    disableGroupTickets: false,
    clientStateReady: false,
    contactLinkTitle: '',
    groupMaxMessage: 'For 25 or more tickets please contact our Visitor Services Team on <span className="nowrap">+44 (0)345 084 0900</span>. If you are a <a href="/travel-partners">Travel Partner</a> looking to book tickets please click here for more information.',
    groupPriceMessage: 'Group prices have been applied.',
    availMaxedMessage: 'You have the maximum number of tickets available for the time you selected. To add more tickets, please selected another time.'
  });
};

export default configStore;
